module.exports = __webpack_public_path__ + "static/img/logo2.5a0ffdf7.png";